import {
  BACKUP365_REPORT_LOADING,
  BACKUP365_REPORT_LOADED,
  BACKUP365_REPORT_COMPANIES_LOADED,
  BACKUP365_REPORT_COMPANY_SELECTED,
  BACKUP365_REPORT_DETAILS_LOADED,
  BACKUP365_REPORT_DETAILS_NOTFOUND,
  BACKUP365_REPORT_COMPANIES_NOTFOUND,
  BACKUP365_REPORT_DATES_NOTFOUND,
  BACKUP365_REPORT_DATES_LOADED,
  BACKUP365_REPORT_DATE_SELECTED,
  BACKUP365_REPORT_DATE_CLEARED,
  BACKUP365_REPORT_RECONS_LOADED,
  BACKUP365_REPORT_RECONS_NOTFOUND,
  BACKUP365_REPORT_PENDING_RECON_LOADED,
  BACKUP365_REPORT_PENDING_RECON_NOTFOUND,
  BACKUP365_REPORT_ADD_RECON_USERS_REQUEST,
  BACKUP365_REPORT_ADD_RECON_USERS_SUCCESS,
  BACKUP365_REPORT_ADD_RECON_USERS_FAILURE,
  BACKUP365_REPORT_REFRESH_RECON_LOADING,
  BACKUP365_REPORT_REFRESH_RECON_LOADED,
  BACKUP365_REPORT_REFRESH_RECON_FAILED,
  BACKUP365_EXCLUDED_DOMAINS_SAVING,
  BACKUP365_EXCLUDED_DOMAINS_SAVED,
  BACKUP365_EXCLUDED_DOMAINS_SAVE_FAILED,
} from '../components/actions/backup365ReportsTypes'

const initialState = {
  loading: false,
  selectedCompany: null,
  reportDetails: null,
  addUsersLoading: false,
}

export default function backup365ReportsReducer(state = initialState, action) {
  switch (action.type) {
    case BACKUP365_REPORT_LOADING:
      return { ...state, loading: true }
    case BACKUP365_REPORT_LOADED:
      return { ...state, loading: false }
    case BACKUP365_REPORT_COMPANIES_LOADED:
      return { ...state, companyLabels: action.payload, loading: false }
    case BACKUP365_REPORT_COMPANY_SELECTED:
      return { ...state, selectedCompany: action.payload }
    case BACKUP365_REPORT_DETAILS_LOADED:
      return { ...state, reportDetails: action.payload, loading: false }
    case BACKUP365_REPORT_DETAILS_NOTFOUND:
      return { ...state, reportDetails: null, loading: false }
    case BACKUP365_REPORT_COMPANIES_NOTFOUND:
      return { ...state, companyLabels: [], loading: false }
    case BACKUP365_REPORT_DATES_LOADED:
      return { ...state, reportDates: action.payload, loading: false }
    case BACKUP365_REPORT_DATES_NOTFOUND:
      return { ...state, reportDates: [], loading: false }
    case BACKUP365_REPORT_DATE_SELECTED:
      return { ...state, selectedReportDate: action.payload }
    case BACKUP365_REPORT_DATE_CLEARED:
      return { ...state, selectedReportDate: null }
    case BACKUP365_REPORT_RECONS_LOADED:
      return { ...state, backupRecons: action.payload, loading: false }
    case BACKUP365_REPORT_RECONS_NOTFOUND:
      return { ...state, backupRecons: [], loading: false }
    case BACKUP365_REPORT_PENDING_RECON_NOTFOUND:
      return { ...state, pendingCompanyRecon: null, loading: false }
    case BACKUP365_REPORT_PENDING_RECON_LOADED:
      return { ...state, pendingCompanyRecon: action.payload, loading: false }
    case BACKUP365_REPORT_ADD_RECON_USERS_REQUEST:
      return { ...state, addUsersLoading: true, addUsersError: null }
    case BACKUP365_REPORT_ADD_RECON_USERS_SUCCESS:
      return {
        ...state,
        addUsersLoading: false,
      }
    case BACKUP365_REPORT_ADD_RECON_USERS_FAILURE:
      return {
        ...state,
        addUsersLoading: false,
        addUsersError: action.payload,
      }
    case BACKUP365_REPORT_REFRESH_RECON_LOADING:
      return {
        ...state,
        refreshReconloadingIndex: action.payload,
      }
    case BACKUP365_REPORT_REFRESH_RECON_LOADED: {
      const { index, recon } = action.payload
      const newList = [...state.backupRecons]
      newList[index] = recon
      return {
        ...state,
        refreshReconloading: false,
        backupRecons: newList,
        refreshReconloadingIndex: null,
      }
    }
    case BACKUP365_REPORT_REFRESH_RECON_FAILED:
      return { ...state, refreshReconloadingIndex: null }
    case BACKUP365_EXCLUDED_DOMAINS_SAVING: {
      return { ...state, savingExcludedDomains: true, saveExcludedDomainsError: null }
    }
    case BACKUP365_EXCLUDED_DOMAINS_SAVE_FAILED: {
      return { ...state, savingExcludedDomains: false, saveExcludedDomainsError: action.payload }
    }
    case BACKUP365_EXCLUDED_DOMAINS_SAVED: {
      return { ...state, savingExcludedDomains: false }
    }

    default:
      return state
  }
}
